var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('PageTitle', [_vm._v("很抱歉！您的帳號已被停用，無法進行下單，如有相關疑問請與客服聯繫：")]), _vm._m(0)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-text-center s-space-y-4"
  }, [_c('p', [_vm._v("寶雅 / 寶雅醫美放"), _c('br'), _vm._v("0800-033-168")]), _c('p', [_vm._v("寶家放"), _c('br'), _vm._v("0800-033-158")])]);
}]

export { render, staticRenderFns }